export default function partition<T>(
  array: T[],
  callback: (item: T, index: number) => boolean,
): [T[], T[]] {
  return array.reduce(
    ([a, b], item, index) => {
      if (callback(item, index)) {
        a.push(item);
      } else {
        b.push(item);
      }
      return [a, b];
    },
    [[], []],
  );
}
